import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { TID } from "@/lib/testIds";

const ADMIN_ROLES = ["owner", "store_manager", "content", "client_care"];

const AdminLogin = () => {
  const { login, logout } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const u = await login(email, password);
      if (!ADMIN_ROLES.includes(u.role)) {
        logout();
        setError("This account does not have atelier access.");
      } else {
        nav("/admin");
      }
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Please try again.");
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-cocoa text-cream flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <p className="font-serif text-3xl tracking-[0.14em] text-center mb-2">NOIRBYAMARA</p>
        <p className="overline text-gold text-center mb-10">Atelier Access</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-[0.68rem] tracking-[0.14em] uppercase text-cream/50 mb-1.5">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid={TID.adminEmail}
              className="w-full bg-transparent border border-cream/30 px-3 py-3 text-sm outline-none focus:border-gold" />
          </div>
          <div>
            <label className="block text-[0.68rem] tracking-[0.14em] uppercase text-cream/50 mb-1.5">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid={TID.adminPassword}
              className="w-full bg-transparent border border-cream/30 px-3 py-3 text-sm outline-none focus:border-gold" />
          </div>
          {error && <p className="text-sm text-gold">{error}</p>}
          <button type="submit" disabled={busy} data-testid={TID.adminLogin}
            className="w-full bg-cream text-cocoa py-3.5 text-[0.72rem] tracking-[0.2em] uppercase hover:bg-gold hover:text-cream transition-colors disabled:opacity-50">
            {busy ? "Entering…" : "Enter"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
